import { MlsCrypto } from "./mls.js";
import type { CryptoProvider } from "./types.js";

/** The app's single crypto engine — every caller uses only the CryptoProvider interface. */
export const cryptoEngine: CryptoProvider = new MlsCrypto();

export type { CryptoProvider } from "./types.js";
export * from "./types.js";
